/**
 * Max length of the eligibility override justification an admin types when selecting a creative
 * that failed eligibility rules (ISSUE-2946).
 *
 * Mirrors `SelectCreativeForOrderDTO.MAX_OVERRIDE_REASON_LENGTH` in backend-platform, which both
 * select DTOs validate against with `@Size(max = ...)`. Enforced client-side so the admin is
 * truncated at the input rather than losing the whole submission to a 400.
 */
export const MAX_CREATIVE_ELIGIBILITY_OVERRIDE_REASON_LENGTH = 1000
